import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { headingFonts } from "../Styles/Styles";

function Breadcrumb({ items }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        pt: 2,
        pb: 2,
        backgroundColor: "#F8FAFD",
      }}
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          maxWidth: "95%",
          margin: "auto",
          "& .MuiBreadcrumbs-separator": {
            color: "var(--primary-color)", // Set separator color to red
          },
        }}
        separator="›"
      >
        {items.map((item, index) =>
          index === items.length - 1 ? (
            <>
              {item.label && (
                <Typography
                  key={index}
                  color="text.primary"
                  sx={{ ...headingFonts }}
                >
                  {item.label.split(" ").slice(0, 8).join(" ")}
                  {/* Limit to 8 words */}
                  {item.label.split(" ").length > 8 && "..."}
                  {/* Add ellipsis if text is truncated */}
                </Typography>
              )}
            </>
          ) : (
            <Link
              key={index}
              underline="hover"
              color="inherit"
              onClick={() => navigate(item.path)}
              sx={{
                ...headingFonts,
                cursor: "pointer",
              }}
            >
              {item.label}
            </Link>
          )
        )}
      </Breadcrumbs>
    </Box>
  );
}

export default Breadcrumb;
